export enum ESortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum EQueryParam {
  Offset = 'offset',
  Limit = 'limit',
  SortBy = 'sortBy',
  SortingDirection = 'sortingDirection',
}

export enum ERole {
  Admin = 'admin',
  Merchant = 'merchant',
  Supplier = 'supplier',
  Superadmin = 'SUPER_ADMIN',
}

export enum ERoleRequest {
  Admin = 'ADMIN',
  Merchant = 'MERCHANT',
  Supplier = 'SUPPLIER',
  Superadmin = 'SUPER_ADMIN',
  TZadmin = 'TZ_ADMIN',
  EXTERNAL_ENTITY = 'EXTERNAL_ENTITY',
  DATA_ANALYST = 'DATA_ANALYST',
  CC_TEAM = 'CC_TEAM',
}

export type TMeta = {
  totalCount: number
  /** True when more records match than totalCount shows; totalCount is then the backend's cap. */
  totalCountCapped?: boolean
  page?: number
  perPage?: number
}

export type TSettings = {
  hideGlobalBrands: boolean
  bnplMinInstallments?: number | null
  bnplMaxInstallments?: number | null
}

export type Permission = {
  action: string
  subject: string
}

export type PermissionsGroup = {
  subjectTitle: string
  permissions: Permission[]
}

export const locales = ['EN', 'AR', 'KU', 'TR', 'UR'] as const
export type Locale = (typeof locales)[number]

export type TCatalogTableData = {
  id: string
  slug: string
  createdAt: string
  updatedAt: string
  contentId: string
  catalogCategories: number[]
  catalogBrands: number[]
  content: {
    id: string
    slug: string
    createdAt: string
    updatedAt: string
  }
}

export type TContent = {
  carousel: Array<{
    image: string
    link: string
  }>
  banners: Array<{
    image: string
    link: string
  }>
  info?: {
    title: string
    description: string
  }
}

export type TContentTranslation = {
  contentId: string
  locale: string
  data: TContent
}

export type TContentTableData = {
  id: string
  slug: string
  createdAt: string
  updatedAt: string
  translations: TContentTranslation[]
}
